<template>
  <v-container fluid style="background-color: #f5f5f5; color: #333333; padding: 20px;">
    <h1 class="text-center mb-5 primary--text">Gestión de Vehículos con Pedidos de Secuestro</h1>
    
    <!-- Filtros de búsqueda -->
    <v-card class="mb-6" elevation="3">
      <v-card-text>
        <v-row>
          <v-col cols="12" md="3">
            <v-menu
              v-model="fechaMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template #activator="{ on, attrs }">
                <v-text-field
                  v-model="filtros.fecha_denuncia"
                  label="Fecha Denuncia"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  dense
                  clearable
                  color="primary"
                />
              </template>
              <v-date-picker
                v-model="filtros.fecha_denuncia"
                @input="fechaMenu = false"
              />
            </v-menu>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="filtros.patente"
              label="Dominio"
              outlined
              dense
              clearable
              prepend-inner-icon="mdi-car"
              color="primary"
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="filtros.numeroMotor"
              label="Número de Motor"
              outlined
              dense
              clearable
              prepend-inner-icon="mdi-engine"
              color="primary"
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="filtros.chasis"
              label="Número de Chasis"
              outlined
              dense
              clearable
              prepend-inner-icon="mdi-car-info"
              color="primary"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <v-select
              v-model="filtros.denuncia"
              :items="tiposDenuncia"
              label="Tipo de Denuncia"
              outlined
              dense
              clearable
              prepend-inner-icon="mdi-alert-circle"
              color="primary"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="filtros.dependencia"
              label="Dependencia"
              outlined
              dense
              clearable
              prepend-inner-icon="mdi-map-marker"
              color="primary"
            />
          </v-col>
        </v-row>
          <v-col cols="12" md="6" class="d-flex justify-end">
            <v-btn color="primary" class="mr-2" @click="buscarVehiculos">
              <v-icon left>mdi-magnify</v-icon>
              Buscar
            </v-btn>
            <v-btn color="success" class="mr-2" @click="mostrarDialogoNuevo">
              <v-icon left>mdi-plus</v-icon>
              Nuevo Pedido
            </v-btn>
            <!-- <v-btn color="info" @click="enviarRegistrosMendoza" :loading="enviandoMendoza">
              <v-icon left>mdi-send</v-icon>
              Enviar a Mendoza
            </v-btn> -->
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    
    <!-- Tabla de vehículos -->
    <v-card elevation="3">
      <v-data-table
        :headers="headers"
        :items="vehiculos"
        :items-per-page="10"
        :loading="loading"
        class="elevation-1"
        :search="search"
        :footer-props="{
          'items-per-page-options': [5, 10, 15, 20],
          'items-per-page-text': 'Registros por página',
        }"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>Listado de Vehículos con Pedidos de Secuestro</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Buscar"
              single-line
              hide-details
              class="mr-4"
              style="max-width: 300px;"
            ></v-text-field>
          </v-toolbar>
        </template>

        <!-- Estado del pedido -->
        <template #item.estadoPedido="{ item }">
          <v-chip
            :color="getEstadoColor(item.estadoPedido)"
            text-color="white"
            small
          >
            {{ item.estadoPedido }}
          </v-chip>
        </template>

        <!-- Control fronterizo -->
        <template #item.controlFronterizo="{ item }">
          <v-chip
            v-if="item.controlFronterizo"
            color="info"
            text-color="white"
            small
          >
            {{ item.controlFronterizo }}
          </v-chip>
          <span v-else>No registrado</span>
        </template>
        
        <!-- Enviado a Mendoza -->
        <template #item.enviado_mendoza="{ item }">
          <v-chip
            :color="item.enviado_mendoza === 'Sí' ? 'success' : 'warning'"
            text-color="white"
            small
          >
            {{ item.enviado_mendoza }}
          </v-chip>
        </template>

        <!-- Acciones -->
        <template #item.actions="{ item }">
          <v-icon
            small
            class="mr-2"
            @click="editarVehiculo(item)"
            color="primary"
          >
            mdi-pencil
          </v-icon>
          <v-icon
            small
            @click="eliminarVehiculo(item)"
            color="error"
          >
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
    </v-card>

    <!-- Diálogo para nuevo pedido o edición -->
    <v-dialog v-model="dialog" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ formTitle }}</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-form ref="form" v-model="valid">
              <v-row>
                <v-col cols="12" md="6">
                  <v-menu
                    v-model="fechaMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template #activator="{ on, attrs }">
                      <v-text-field
                        v-model="editedItem.fecha_denuncia"
                        label="Fecha Denuncia"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        dense
                        required
                        :rules="[v => !!v || 'Fecha de denuncia es requerida']"
                      />
                    </template>
                    <v-date-picker
                      v-model="editedItem.fecha_denuncia"
                      @input="fechaMenu = false"
                    />
                  </v-menu>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="editedItem.patente"
                    label="Dominio"
                    required
                    :rules="[v => !!v || 'Dominio es requerido']"
                    outlined
                    dense
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="editedItem.marca"
                    label="Marca"
                    required
                    :rules="[v => !!v || 'Marca es requerida']"
                    outlined
                    dense
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="editedItem.modelo"
                    label="Modelo"
                    required
                    :rules="[v => !!v || 'Modelo es requerido']"
                    outlined
                    dense
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="editedItem.color"
                    label="Color"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="editedItem.numeroMotor"
                    label="Número de Motor"
                    required
                    :rules="[v => !!v || 'Número de motor es requerido']"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="editedItem.chasis"
                    label="Número de Chasis"
                    required
                    :rules="[v => !!v || 'Número de chasis es requerido']"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    v-model="editedItem.estadoPedido"
                    :items="estadosOptions"
                    label="Tipo de Denuncia"
                    required
                    :rules="[v => !!v || 'Tipo de denuncia es requerido']"
                    outlined
                    dense
                  ></v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="editedItem.controlFronterizo"
                    label="Dependencia"
                    outlined
                    dense
                  />
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="editedItem.observaciones"
                    label="Observaciones"
                    outlined
                    auto-grow
                    rows="3"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="cerrarDialogo">Cancelar</v-btn>
          <v-btn color="success" text @click="guardarVehiculo" :disabled="!valid">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo de confirmación para eliminar -->
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">¿Está seguro que desea eliminar este registro?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogDelete = false">Cancelar</v-btn>
          <v-btn color="error" text @click="confirmarEliminacion">Confirmar</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import verificadoraService from '@/services/verificadoraService';

export default {
  name: 'VehiculosSecuestroView',
  data() {
    return {
      search: '',
      loading: false,
      dialog: false,
      dialogDelete: false,
      valid: true,
      headers: [
        { text: 'Fecha Denuncia', value: 'fecha_denuncia', align: 'start' },
        { text: 'Dominio', value: 'patente' },
        { text: 'Marca', value: 'marca' },
        { text: 'Modelo', value: 'modelo' },
        { text: 'Color', value: 'color' },
        { text: 'N° Motor', value: 'numeroMotor' },
        { text: 'N° Chasis', value: 'chasis' },
        { text: 'Tipo Denuncia', value: 'estadoPedido' },
        { text: 'Dependencia', value: 'controlFronterizo' },
        { text: 'Enviado a Mendoza', value: 'enviado_mendoza' },
        { text: 'Acciones', value: 'actions', sortable: false }
      ],
      vehiculos: [],
      filtros: {
        fecha_denuncia: '',
        patente: '',
        numeroMotor: '',
        chasis: '',
        denuncia: '',
        dependencia: ''
      },
      fechaMenu: false,
      tiposDenuncia: ['PEDIDO DE SECUESTRO', 'SIN EFECTO'],
      estadosOptions: ['PEDIDO DE SECUESTRO', 'SIN EFECTO'],
      controlesFronterizos: ['San Carlos', 'Uspallata', 'La Quiaca', 'Gualeguaychú', 'Paso de los Libres'],
      editedIndex: -1,
      enviandoMendoza: false,
      editedItem: {
        id: '',
        fecha_denuncia: new Date().toISOString().split('T')[0],
        vehiculo: 'AUTOMOVIL',
        patente: '',
        marca: '',
        modelo: '',
        color: '',
        numeroMotor: '',
        chasis: '',
        estadoPedido: 'PEDIDO DE SECUESTRO',
        controlFronterizo: '',
        observaciones: '',
        srio: ''
      },
      defaultItem: {
        id: '',
        fecha_denuncia: new Date().toISOString().split('T')[0],
        vehiculo: 'AUTOMOVIL',
        patente: '',
        marca: '',
        modelo: '',
        color: '',
        numeroMotor: '',
        chasis: '',
        estadoPedido: 'PEDIDO DE SECUESTRO',
        controlFronterizo: '',
        observaciones: '',
        srio: ''
      }
    };
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'Nuevo Pedido de Secuestro' : 'Editar Pedido de Secuestro';
    }
  },
  created() {
    // Cargar datos reales desde la API
    this.cargarPedidosSecuestro();
  },
  methods: {
    // Cargar pedidos de secuestro desde la API
    cargarPedidosSecuestro() {
      this.loading = true;
      verificadoraService.getAllPedidos()
        .then(response => {
          // Mapear los datos recibidos al formato esperado por la tabla
          this.vehiculos = response.data.map(item => ({
            id: item.id,
            fecha_denuncia: item.fecha_denuncia,
            vehiculo: item.vehiculo,
            patente: item.dominio,
            marca: item.marca,
            modelo: item.modelo,
            color: item.color,
            numeroMotor: item.motor,
            chasis: item.chasis,
            estadoPedido: item.denuncia,
            controlFronterizo: item.dependencia || '',
            observaciones: item.delito || '',
            denuncia: item.denuncia,
            delito: item.delito,
            dependencia: item.dependencia,
            srio: item.srio,
            enviado_mendoza: item.enviado_mendoza ? 'Sí' : 'No',
            fecha_enviado_mendoza: item.fecha_enviado_mendoza
          }));
        })
        .catch(error => {
          console.error('Error al cargar los pedidos de secuestro:', error);
          this.$store.dispatch('snackbar/showMessage', {
            text: 'Error al cargar los pedidos de secuestro',
            color: 'error'
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    
    // Inicializar datos mock (mantenido para referencia)
    inicializarDatosMock() {
      this.vehiculos = [
        {
          id: '1',
          patente: 'ABC123',
          marca: 'Toyota',
          modelo: 'Corolla',
          color: 'Blanco',
          numeroMotor: 'M123456789',
          chasis: 'CH987654321',
          estadoPedido: 'Activo',
          controlFronterizo: 'San Carlos',
          observaciones: 'Vehículo robado en San Juan el 10/05/2023'
        },
        {
          id: '2',
          patente: 'DEF456',
          marca: 'Ford',
          modelo: 'Focus',
          color: 'Negro',
          numeroMotor: 'M987654321',
          chasis: 'CH123456789',
          estadoPedido: 'Inactivo',
          controlFronterizo: '',
          observaciones: 'Pedido de secuestro cancelado el 15/06/2023'
        },
        {
          id: '3',
          patente: 'GHI789',
          marca: 'Chevrolet',
          modelo: 'Cruze',
          color: 'Rojo',
          numeroMotor: 'M456789123',
          chasis: 'CH789123456',
          estadoPedido: 'Activo',
          controlFronterizo: 'Uspallata',
          observaciones: 'Vehículo con pedido de secuestro internacional'
        },
        {
          id: '4',
          patente: 'JKL012',
          marca: 'Volkswagen',
          modelo: 'Golf',
          color: 'Azul',
          numeroMotor: 'M321654987',
          chasis: 'CH654987321',
          estadoPedido: 'En Proceso',
          controlFronterizo: '',
          observaciones: 'Verificando datos del vehículo'
        },
        {
          id: '5',
          patente: 'MNO345',
          marca: 'Renault',
          modelo: 'Sandero',
          color: 'Gris',
          numeroMotor: 'M741852963',
          chasis: 'CH963852741',
          estadoPedido: 'Activo',
          controlFronterizo: 'San Carlos',
          observaciones: 'Vehículo con pedido de secuestro por causa judicial'
        }
      ];
    },
    
    // Obtener color según estado
    getEstadoColor(estado) {
      if (estado === 'PEDIDO DE SECUESTRO') return 'error';
      if (estado === 'SIN EFECTO') return 'success';
      return 'warning';
    },
    
    // Buscar vehículos según filtros
    buscarVehiculos() {
      this.loading = true;
      
      // Obtener todos los pedidos y filtrar en el cliente
      // En una implementación más avanzada, se podría enviar los filtros al servidor
      verificadoraService.getAllPedidos()
        .then(response => {
          // Mapear los datos recibidos al formato esperado por la tabla
          const vehiculos = response.data.map(item => ({
            id: item.id,
            fecha_denuncia: item.fecha_denuncia,
            vehiculo: item.vehiculo,
            patente: item.dominio,
            marca: item.marca,
            modelo: item.modelo,
            color: item.color,
            numeroMotor: item.motor,
            chasis: item.chasis,
            estadoPedido: item.denuncia,
            controlFronterizo: item.dependencia || '',
            observaciones: item.delito || '',
            denuncia: item.denuncia,
            delito: item.delito,
            dependencia: item.dependencia,
            srio: item.srio,
            enviado_mendoza: item.enviado_mendoza ? 'Sí' : 'No',
            fecha_enviado_mendoza: item.fecha_enviado_mendoza
          }));
          
          // Filtrar los resultados según los criterios
          const resultados = vehiculos.filter(v => {
            return (!this.filtros.fecha_denuncia || v.fecha_denuncia === this.filtros.fecha_denuncia) &&
                   (!this.filtros.patente || v.patente.toLowerCase().includes(this.filtros.patente.toLowerCase())) &&
                   (!this.filtros.numeroMotor || v.numeroMotor.toLowerCase().includes(this.filtros.numeroMotor.toLowerCase())) &&
                   (!this.filtros.chasis || v.chasis.toLowerCase().includes(this.filtros.chasis.toLowerCase())) &&
                   (!this.filtros.denuncia || v.denuncia === this.filtros.denuncia) &&
                   (!this.filtros.dependencia || v.dependencia === this.filtros.dependencia);
          });
          
          // Actualizar la tabla con los resultados filtrados
          this.vehiculos = resultados;
        })
        .catch(error => {
          console.error('Error al buscar vehículos:', error);
          this.$store.dispatch('snackbar/showMessage', {
            text: 'Error al buscar vehículos',
            color: 'error'
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    
    // Mostrar diálogo para nuevo vehículo
    mostrarDialogoNuevo() {
      this.editedIndex = -1;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.dialog = true;
    },
    
    // Editar vehículo
    editarVehiculo(item) {
      this.editedIndex = this.vehiculos.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    
    // Eliminar vehículo
    eliminarVehiculo(item) {
      this.editedIndex = this.vehiculos.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },
    
    // Confirmar eliminación
    confirmarEliminacion() {
      const id = this.editedItem.id;
      this.loading = true;
      
      verificadoraService.deletePedido(id)
        .then(() => {
          // Eliminar el registro de la tabla local
          this.vehiculos.splice(this.editedIndex, 1);
          this.cerrarDialogoEliminar();
          
          // Mostrar notificación
          this.$store.dispatch('snackbar/showMessage', {
            text: 'Registro eliminado correctamente',
            color: 'success'
          });
        })
        .catch(error => {
          console.error('Error al eliminar el registro:', error);
          this.$store.dispatch('snackbar/showMessage', {
            text: 'Error al eliminar el registro',
            color: 'error'
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    
    // Cerrar diálogo de eliminación
    cerrarDialogoEliminar() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    
    // Cerrar diálogo
    cerrarDialogo() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.$refs.form.reset();
      });
    },
    
    // Guardar vehículo
    guardarVehiculo() {
      if (!this.$refs.form.validate()) return;
      
      this.loading = true;
      
      // Preparar datos para enviar a la API
      const pedidoData = {
        id: this.editedItem.id || undefined,
        fecha_denuncia: this.editedItem.fecha_denuncia,
        vehiculo: this.editedItem.vehiculo,
        dominio: this.editedItem.patente,
        marca: this.editedItem.marca,
        modelo: this.editedItem.modelo,
        color: this.editedItem.color,
        motor: this.editedItem.numeroMotor,
        chasis: this.editedItem.chasis,
        denuncia: this.editedItem.estadoPedido,
        delito: this.editedItem.observaciones,
        dependencia: this.editedItem.controlFronterizo,
        srio: this.editedItem.srio || ''
      };
      
      // Determinar si es una actualización o creación
      const promise = this.editedIndex > -1 ?
        verificadoraService.updatePedido(pedidoData) :
        verificadoraService.createPedido(pedidoData);
      
      promise
        .then(response => {
          if (this.editedIndex > -1) {
            // Actualizar el registro en la tabla local
            Object.assign(this.vehiculos[this.editedIndex], this.editedItem);
            
            // Mostrar notificación
            this.$store.dispatch('snackbar/showMessage', {
              text: 'Registro actualizado correctamente',
              color: 'success'
            });
          } else {
            // Agregar el nuevo registro a la tabla local
            const nuevoRegistro = {
              ...this.editedItem,
              id: response.data.id || Date.now().toString() // Usar el ID devuelto por la API o generar uno
            };
            this.vehiculos.push(nuevoRegistro);
            
            // Mostrar notificación
            this.$store.dispatch('snackbar/showMessage', {
              text: 'Registro creado correctamente',
              color: 'success'
            });
          }
          
          this.cerrarDialogo();
        })
        .catch(error => {
          console.error('Error al guardar el registro:', error);
          this.$store.dispatch('snackbar/showMessage', {
            text: 'Error al guardar el registro',
            color: 'error'
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    
    // Enviar registros pendientes a Mendoza
    enviarRegistrosMendoza() {
      this.enviandoMendoza = true;
      
      verificadoraService.enviarRegistrosMendoza()
        .then(() => {
          // Mostrar notificación
          this.$store.dispatch('snackbar/showMessage', {
            text: 'Registros enviados correctamente a Mendoza',
            color: 'success'
          });
          
          // Recargar los datos para reflejar los cambios
          this.cargarPedidosSecuestro();
        })
        .catch(error => {
          console.error('Error al enviar registros a Mendoza:', error);
          this.$store.dispatch('snackbar/showMessage', {
            text: 'Error al enviar registros a Mendoza',
            color: 'error'
          });
        })
        .finally(() => {
          this.enviandoMendoza = false;
        });
    }
  }
}
</script>

<style scoped>
.v-data-table {
  background-color: white;
}

.v-data-table th {
  font-weight: bold !important;
  background-color: #f0f0f0 !important;
}

.v-chip {
  font-weight: 500;
}
</style>
